module.exports = __webpack_public_path__ + "img/P10.4703bf99.png";